import { Platform } from 'react-native';
import { DropDownItemType } from './types';
import { constants } from '@/config/constants';

export const getDropdownItems = ({
  showLicenseWarning,
}: {
  showLicenseWarning: boolean;
}): DropDownItemType[] => [
  { title: 'Anleitung', bold: false, iconName: undefined },
  { title: 'Mein Benutzerkonto', bold: false, iconName: undefined },
  {
    title: 'Rezeptcode einlösen',
    bold: false,
    iconName: showLicenseWarning ? 'alertTriangle' : undefined,
    iconColor: showLicenseWarning ? 'text-yellow-500' : undefined,
  },
  {
    title: 'Lizenz buchen',
    bold: false,
    iconName: undefined,
    hide: constants.bookingPageVisible == 'false' || Platform.OS !== 'web',
  },
  { title: 'Einwilligungen', bold: false, iconName: undefined },
  { title: 'Über die App', bold: false, iconName: undefined },
  { title: 'Kontakt', bold: false, iconName: undefined },
  { title: 'Ergebnisse ansehen', bold: false, iconName: undefined },
  {
    title: 'Abmelden',
    bold: true,
    iconName: 'closesquare',
    iconColor: 'text-red-400',
  },
];
